import { APP_INITIALIZER, EnvironmentProviders, FactorySansProvider, InjectionToken, makeEnvironmentProviders } from '@angular/core';

import { APP_FEATURE_FLAGS_HTTP_CLIENT } from './app-features-flags-http-client.token';
import { HttpClient } from '@angular/common/http';

import { AppFeatureFlagsHttpService } from './app-feature-flags-http.service';

export const provideAppFeatureFlags = (
  httpApiClientToken: InjectionToken<HttpClient>,
  factory: FactorySansProvider = { useFactory: featureFlagFactory, deps: [AppFeatureFlagsHttpService] },
): EnvironmentProviders =>
  makeEnvironmentProviders([
    { provide: APP_FEATURE_FLAGS_HTTP_CLIENT, useExisting: httpApiClientToken },
    { provide: APP_INITIALIZER, ...factory, multi: true },
  ]);

const featureFlagFactory = (appFeatureFlagsHttpService: AppFeatureFlagsHttpService) => () => appFeatureFlagsHttpService.fetchFeatureFlags();
